import { useSubMenu } from '../SubMenuContext';
import { motion } from 'framer-motion';

interface NovoButtonProps {
	skipSidebar?: boolean;
}

const NovoButton = ({ skipSidebar = false }: NovoButtonProps) => {
	const { isSidebarOpen } = useSubMenu();

	return (
		<motion.div initial={{ opacity: skipSidebar ? 1 : isSidebarOpen ? 1 : 0 }} animate={{ opacity: skipSidebar ? 1 : isSidebarOpen ? 1 : 0 }} transition={{ duration: 0.25, ease: [0, 0.71, 0.2, 1.01] }} className='bg-teal-50 text-[#047857] px-1 py-0 font-medium text-[0.625rem] rounded-lg'>
			Novo
		</motion.div>
	);
};

export default NovoButton;
